// src/pages/Usuarios.jsx
import React, { useState } from "react";
import { useCotizaciones } from "../hooks/useCotizaciones";
import { useUsuarios, useRol } from "../hooks/useRoles";

const INICIAL = { nombre:"", email:"", password:"", rol:"asesor", telefono:"" };

export default function Usuarios() {
  const { usuarios, loading, crearUsuario, actualizarUsuario, desactivarUsuario } = useUsuarios();
  const { esAdmin } = useRol();
  const { cotizaciones } = useCotizaciones();

  const cotPorAsesor = (nombre) =>
    cotizaciones.filter(c => c.responsable === nombre && !["Ganada","Cerrada","Aprobada","Perdida","Rechazada","Vencida"].includes(c.estado)).length;

  const [form,     setForm]     = useState(INICIAL);
  const [mostrar,  setMostrar]  = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [error,    setError]    = useState("");
  const [exito,    setExito]    = useState("");

  if (!esAdmin) return (
    <div style={{textAlign:"center",padding:60,color:"#94a3b8"}}>
      No tienes permiso para ver esta página.
    </div>
  );

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setExito(""); setEnviando(true);
    const res = await crearUsuario(form);
    if (res.ok) {
      setExito(`✅ Usuario ${form.nombre} creado correctamente`);
      setForm(INICIAL);
      setMostrar(false);
    } else {
      if (res.error.includes("email-already-in-use")) setError("❌ Ese email ya está registrado");
      else if (res.error.includes("weak-password"))   setError("❌ La contraseña debe tener al menos 6 caracteres");
      else setError("❌ Error: " + res.error);
    }
    setEnviando(false);
  };

  const admins   = usuarios.filter(u => u.rol === "admin");
  const asesores = usuarios.filter(u => u.rol === "asesor");

  if (loading) return <div style={{textAlign:"center",padding:60,color:"#94a3b8"}}>Cargando usuarios...</div>;

  return (
    <div style={{maxWidth:900,margin:"0 auto",padding:"0 16px"}}>

      {/* Header */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <h1 style={{fontSize:22,fontWeight:700,color:"#1e293b"}}>Gestión de usuarios</h1>
        <button onClick={() => { setMostrar(!mostrar); setError(""); setExito(""); }} style={btnP}>
          {mostrar ? "Cancelar" : "+ Nuevo usuario"}
        </button>
      </div>

      {error && <div style={{background:"#fee2e2",color:"#991b1b",padding:"10px 14px",borderRadius:8,marginBottom:12,fontSize:13}}>{error}</div>}
      {exito && <div style={{background:"#d1fae5",color:"#065f46",padding:"10px 14px",borderRadius:8,marginBottom:12,fontSize:13}}>{exito}</div>}

      {/* Formulario nuevo usuario */}
      {mostrar && (
        <form onSubmit={handleSubmit} style={{background:"#fff",border:"1px solid #e2e8f0",borderRadius:12,padding:20,marginBottom:20}}>
          <p style={{fontSize:12,fontWeight:700,color:"#2563eb",marginBottom:14,textTransform:"uppercase",letterSpacing:"0.06em"}}>
            Crear nuevo usuario
          </p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
            <div>
              <label style={lbl}>Nombre completo *</label>
              <input name="nombre" value={form.nombre} onChange={handleChange} required placeholder="Ej: Ana Torres" style={inp}/>
            </div>
            <div>
              <label style={lbl}>Email *</label>
              <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="ana@tuempresa.com" style={inp}/>
            </div>
            <div>
              <label style={lbl}>Contraseña * (mínimo 6 caracteres)</label>
              <input name="password" type="password" value={form.password} onChange={handleChange} required minLength={6} placeholder="••••••••" style={inp}/>
            </div>
            <div>
              <label style={lbl}>Teléfono</label>
              <input name="telefono" value={form.telefono} onChange={handleChange} placeholder="987-654-321" style={inp}/>
            </div>
            <div style={{gridColumn:"1/-1"}}>
              <label style={lbl}>Rol *</label>
              <div style={{display:"flex",gap:10}}>
                {["admin","asesor"].map(r => (
                  <div key={r} onClick={() => setForm(prev => ({...prev, rol:r}))} style={{
                    flex:1,padding:"12px 16px",borderRadius:10,cursor:"pointer",
                    border:`2px solid ${form.rol===r ? (r==="admin" ? "#1e3a5f" : "#2563eb") : "#e2e8f0"}`,
                    background: form.rol===r ? (r==="admin" ? "#eff6ff" : "#dbeafe") : "#fff",
                  }}>
                    <div style={{fontSize:13,fontWeight:700,color: form.rol===r ? "#1e3a5f" : "#64748b",marginBottom:4}}>
                      {r === "admin" ? "👑 Administrador" : "💼 Asesor de ventas"}
                    </div>
                    <div style={{fontSize:11,color:"#94a3b8"}}>
                      {r === "admin" ? "Ve todo, gestiona usuarios, puede borrar" : "Ve sus clientes, pedidos y seguimiento"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{display:"flex",gap:10,marginTop:14}}>
            <button type="submit" disabled={enviando} style={{...btnP,flex:1,padding:"10px 0"}}>
              {enviando ? "Creando usuario..." : "Crear usuario"}
            </button>
            <button type="button" onClick={() => setMostrar(false)} style={btnS}>Cancelar</button>
          </div>
        </form>
      )}

      {/* Lista administradores */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:11,fontWeight:600,color:"#64748b",textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:10}}>
          Administradores ({admins.length})
        </div>
        <div style={{display:"grid",gap:8}}>
          {admins.map(u => (
            <UsuarioCard key={u.id} u={u}
              onDesactivar={desactivarUsuario}
              onActualizar={actualizarUsuario}
              cotActivas={cotPorAsesor(u.nombre)}
            />
          ))}
          {admins.length === 0 && <p style={{color:"#94a3b8",fontSize:13}}>Sin administradores registrados.</p>}
        </div>
      </div>

      {/* Lista asesores */}
      <div>
        <div style={{fontSize:11,fontWeight:600,color:"#64748b",textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:10}}>
          Asesores de ventas ({asesores.length})
        </div>
        <div style={{display:"grid",gap:8}}>
          {asesores.map(u => (
            <UsuarioCard key={u.id} u={u}
              onDesactivar={desactivarUsuario}
              onActualizar={actualizarUsuario}
              cotActivas={cotPorAsesor(u.nombre)}
            />
          ))}
          {asesores.length === 0 && <p style={{color:"#94a3b8",fontSize:13}}>Sin asesores registrados.</p>}
        </div>
      </div>
    </div>
  );
}

// ── Tarjeta de usuario con edición inline ────────────────────────────────────
function UsuarioCard({ u, onDesactivar, onActualizar, cotActivas }) {
  const [confirm,   setConfirm]   = useState(false);
  const [editando,  setEditando]  = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [editForm,  setEditForm]  = useState({
    nombre:   u.nombre   || "",
    telefono: u.telefono || "",
    rol:      u.rol      || "asesor",
  });

  const initials = (u.nombre||"?").split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase();
  const esAdminUser = u.rol === "admin";

  const abrirEdicion = () => {
    setEditForm({ nombre: u.nombre||"", telefono: u.telefono||"", rol: u.rol||"asesor" });
    setEditando(true);
    setConfirm(false);
  };

  const handleGuardar = async () => {
    if (!editForm.nombre.trim()) return;
    setGuardando(true);
    await onActualizar(u.id, {
      nombre:   editForm.nombre.trim(),
      telefono: editForm.telefono.trim(),
      rol:      editForm.rol,
    });
    setGuardando(false);
    setEditando(false);
  };

  return (
    <div style={{
      background:"#fff", border:"1px solid #e2e8f0", borderRadius:12, overflow:"hidden",
      opacity: u.activo === false ? 0.6 : 1,
      transition: "box-shadow 150ms",
    }}>

      {/* Fila principal */}
      <div style={{padding:"12px 16px",display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>

        {/* Avatar */}
        <div style={{
          width:42,height:42,borderRadius:"50%",flexShrink:0,
          background: esAdminUser ? "#dbeafe" : "#ede9fe",
          color:      esAdminUser ? "#1d4ed8" : "#6d28d9",
          display:"flex",alignItems:"center",justifyContent:"center",
          fontSize:14,fontWeight:700,
        }}>
          {initials}
        </div>

        {/* Info */}
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:2,flexWrap:"wrap"}}>
            <span style={{fontSize:14,fontWeight:600,color:"#1e293b"}}>{u.nombre}</span>
            <span style={{
              fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:10,
              background: esAdminUser ? "#dbeafe" : "#ede9fe",
              color:      esAdminUser ? "#1d4ed8" : "#6d28d9",
            }}>
              {esAdminUser ? "👑 Admin" : "💼 Asesor"}
            </span>
            {u.activo === false && (
              <span style={{fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:10,background:"#fee2e2",color:"#991b1b"}}>
                Inactivo
              </span>
            )}
          </div>
          <div style={{fontSize:11,color:"#94a3b8"}}>
            {u.email}{u.telefono ? ` · ${u.telefono}` : ""}
          </div>
          <div style={{fontSize:10,color:"#3A3C7A",fontWeight:600,marginTop:2}}>
            {cotActivas} cotizaciones activas
          </div>
        </div>

        {/* Acciones */}
        <div style={{display:"flex",gap:6,flexShrink:0}}>
          <button
            onClick={() => editando ? setEditando(false) : abrirEdicion()}
            style={{
              fontSize:11,fontWeight:600,padding:"5px 12px",borderRadius:6,border:"none",cursor:"pointer",
              background: editando ? "#f1f5f9" : "#EEF2FF",
              color:      editando ? "#475569"  : "#3730A3",
            }}
          >
            {editando ? "✕ Cancelar" : "✏️ Editar"}
          </button>

          {u.activo !== false ? (
            confirm ? (
              <div style={{display:"flex",gap:4}}>
                <button
                  onClick={() => { onDesactivar(u.id); setConfirm(false); }}
                  style={{fontSize:11,padding:"5px 10px",borderRadius:6,background:"#dc2626",color:"#fff",border:"none",cursor:"pointer",fontWeight:600}}
                >
                  Sí, desactivar
                </button>
                <button
                  onClick={() => setConfirm(false)}
                  style={{fontSize:11,padding:"5px 10px",borderRadius:6,background:"#f1f5f9",color:"#475569",border:"none",cursor:"pointer"}}
                >
                  No
                </button>
              </div>
            ) : (
              <button
                onClick={() => { setConfirm(true); setEditando(false); }}
                style={{fontSize:11,fontWeight:600,padding:"5px 10px",borderRadius:6,background:"#fee2e2",color:"#991b1b",border:"none",cursor:"pointer"}}
              >
                Desactivar
              </button>
            )
          ) : (
            <button
              onClick={() => onActualizar(u.id, { activo: true })}
              style={{fontSize:11,fontWeight:600,padding:"5px 12px",borderRadius:6,background:"#d1fae5",color:"#065f46",border:"none",cursor:"pointer"}}
            >
              ✓ Reactivar
            </button>
          )}
        </div>
      </div>

      {/* Panel de edición inline */}
      {editando && (
        <div style={{borderTop:"1px solid #f1f5f9",background:"#f8fafc",padding:"16px"}}>
          <p style={{fontSize:11,fontWeight:700,color:"#3A3C7A",textTransform:"uppercase",letterSpacing:"0.06em",margin:"0 0 12px"}}>
            Editar datos del usuario
          </p>

          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            {/* Nombre */}
            <div>
              <label style={lbl}>Nombre completo *</label>
              <input
                value={editForm.nombre}
                onChange={e => setEditForm(f => ({...f, nombre: e.target.value}))}
                placeholder="Nombre completo"
                style={inp}
              />
            </div>

            {/* Teléfono */}
            <div>
              <label style={lbl}>Teléfono</label>
              <input
                value={editForm.telefono}
                onChange={e => setEditForm(f => ({...f, telefono: e.target.value}))}
                placeholder="987-654-321"
                style={inp}
              />
            </div>

            {/* Email — solo lectura */}
            <div style={{gridColumn:"1/-1"}}>
              <label style={lbl}>Email (no editable)</label>
              <input value={u.email} disabled style={{...inp, background:"#f1f5f9", color:"#94a3b8", cursor:"not-allowed"}}/>
              <p style={{fontSize:10,color:"#94a3b8",margin:"3px 0 0"}}>El email está vinculado a Firebase Auth y no se puede cambiar desde aquí.</p>
            </div>

            {/* Rol */}
            <div style={{gridColumn:"1/-1"}}>
              <label style={lbl}>Rol</label>
              <div style={{display:"flex",gap:10}}>
                {["admin","asesor"].map(r => (
                  <div
                    key={r}
                    onClick={() => setEditForm(f => ({...f, rol: r}))}
                    style={{
                      flex:1,padding:"10px 14px",borderRadius:10,cursor:"pointer",
                      border:`2px solid ${editForm.rol===r ? (r==="admin" ? "#1e3a5f" : "#2563eb") : "#e2e8f0"}`,
                      background: editForm.rol===r ? (r==="admin" ? "#eff6ff" : "#dbeafe") : "#fff",
                      transition:"all 150ms",
                    }}
                  >
                    <div style={{fontSize:12,fontWeight:700,color: editForm.rol===r ? "#1e3a5f" : "#64748b",marginBottom:2}}>
                      {r === "admin" ? "👑 Administrador" : "💼 Asesor de ventas"}
                    </div>
                    <div style={{fontSize:10,color:"#94a3b8"}}>
                      {r === "admin" ? "Ve todo, gestiona usuarios, puede borrar" : "Ve sus clientes, pedidos y seguimiento"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{display:"flex",gap:8,marginTop:14}}>
            <button
              onClick={handleGuardar}
              disabled={guardando || !editForm.nombre.trim()}
              style={{
                ...btnP, flex:1, padding:"9px 0",
                opacity: guardando || !editForm.nombre.trim() ? 0.6 : 1,
              }}
            >
              {guardando ? "Guardando..." : "✓ Guardar cambios"}
            </button>
            <button onClick={() => setEditando(false)} style={btnS}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const btnP = {background:"#1e3a5f",color:"#fff",border:"none",borderRadius:8,padding:"8px 18px",fontSize:13,fontWeight:600,cursor:"pointer"};
const btnS = {padding:"8px 18px",border:"1px solid #e2e8f0",borderRadius:8,background:"#fff",fontSize:13,cursor:"pointer",color:"#475569"};
const lbl  = {display:"block",fontSize:11,fontWeight:600,color:"#475569",marginBottom:5};
const inp  = {width:"100%",padding:"9px 12px",border:"1px solid #e2e8f0",borderRadius:8,fontSize:13,color:"#1e293b",outline:"none",background:"#fff",fontFamily:"inherit",boxSizing:"border-box"};
